<div class="w-full h-full flex justify-content-center">
  <div class="flex flex-column step-content">
    <div class="display-sm-semibold text-gray-900">Unesite osnovne podatke</div>
    @if (isLegalEntity()) {
      <div class="mt-2-5 text-md-regular text-gray-600">Ovi podaci se koriste za kreiranje naloga i fakturisanje.</div>
      <div class="mt-5 text-md-semibold text-gray-900">Podaci kompanije</div>
      <app-field label="Naziv kompanije" for="companyName" class="mt-3-5">
        <app-text-input
          [hasIcon]="true"
          ctrlPlaceholder="Unesite naziv kompanije"
          [formCtrl]="form().controls.companyName | formControl"
        >
          <app-building-05 stroke="#ADB0B8"></app-building-05>
        </app-text-input>
      </app-field>
      <div class="mt-3-5 flex flex-column md:flex-row align-items-start md:align-items-center gap-3 md:gap-0">
        <app-field label="PIB" for="pib" class="flex-1 w-full">
          <app-text-input
            [hasIcon]="true"
            ctrlPlaceholder="Unesite PIB"
            [formCtrl]="form().controls.pib | formControl"
          >
            <app-hash-02 stroke="#ADB0B8"></app-hash-02>
          </app-text-input>
        </app-field>
        <app-field label="Matični broj" for="mb" class="md:ml-4 flex-1 w-full">
          <app-text-input
            [hasIcon]="true"
            ctrlPlaceholder="Unesite matični broj"
            [formCtrl]="form().controls.mb | formControl"
          >
            <app-hash-02 stroke="#ADB0B8"></app-hash-02>
          </app-text-input>
        </app-field>
      </div>
      <app-field label="Adresa sedišta" for="address" class="mt-3-5">
        <app-text-input
          [hasIcon]="true"
          ctrlPlaceholder="Unesite adresu"
          [formCtrl]="form().controls.address | formControl"
        >
          <app-home-line stroke="#ADB0B8"></app-home-line>
        </app-text-input>
      </app-field>
      <div class="mt-3-5 flex flex-column md:flex-row align-items-start md:align-items-center gap-3 md:gap-0">
        <app-field label="Grad" for="city" class="flex-1 w-full">
          <app-text-input
            [hasIcon]="true"
            ctrlPlaceholder="Unesite grad"
            [formCtrl]="form().controls.city | formControl"
          >
            <app-marker-pin-01 stroke="#ADB0B8"></app-marker-pin-01>
          </app-text-input>
        </app-field>
        <app-field label="Poštanski broj" for="mb" class="md:ml-4 flex-1 w-full">
          <app-text-input
            [hasIcon]="true"
            ctrlPlaceholder="Unesite poštanski broj"
            [formCtrl]="form().controls.postalCode | formControl"
          >
            <app-map-01 stroke="#ADB0B8"></app-map-01>
          </app-text-input>
        </app-field>
      </div>
      <hr class="my-4 text-gray-200"/>
      <div class="text-md-semibold text-gray-900">Podaci kontakt osobe</div>
      <div class="mt-3-5 flex flex-column md:flex-row align-items-start md:align-items-center gap-3 md:gap-0">
        <app-field label="Ime osobe" for="firstName" class="flex-1 w-full">
          <app-text-input
            [hasIcon]="true"
            ctrlPlaceholder="Unesite ime"
            [formCtrl]="form().controls.firstName | formControl"
          >
            <app-user-01 stroke="#ADB0B8"></app-user-01>
          </app-text-input>
        </app-field>
        <app-field label="Prezime osobe" for="lastName" class="md:ml-4 flex-1 w-full">
          <app-text-input
            [hasIcon]="true"
            ctrlPlaceholder="Unesite prezime"
            [formCtrl]="form().controls.lastName | formControl"
          >
            <app-user-01 stroke="#ADB0B8"></app-user-01>
          </app-text-input>
        </app-field>
      </div>
      <app-field label="Kontakt telefon" for="phone" class="mt-3-5">
        <app-text-input
          formCtrlId="phone"
          ctrlPlaceholder="Unesite kontakt telefon"
          [formCtrl]="form().controls.phoneNumber! | formControl"
          [hasIcon]="true"
        >
          <app-phone stroke="#ADB0B8"></app-phone>
        </app-text-input>
      </app-field>
    } @else {
      <div class="mt-2-5 text-md-regular text-gray-600">Ovi podaci se koriste za kreiranje naloga.</div>
      <div class="mt-3-5 flex flex-column md:flex-row align-items-start md:align-items-center gap-3 md:gap-0">
        <app-field label="Ime" for="firstName" class="flex-1 w-full">
          <app-text-input
            [hasIcon]="true"
            ctrlPlaceholder="Unesite ime"
            [formCtrl]="form().controls.firstName | formControl"
          >
            <app-user-01 stroke="#ADB0B8"></app-user-01>
          </app-text-input>
        </app-field>
        <app-field label="Prezime" for="lastName" class="md:ml-4 flex-1 w-full">
          <app-text-input
            [hasIcon]="true"
            ctrlPlaceholder="Unesite prezime"
            [formCtrl]="form().controls.lastName | formControl"
          >
            <app-user-01 stroke="#ADB0B8"></app-user-01>
          </app-text-input>
        </app-field>
      </div>
      <app-field label="Adresa" for="address" class="mt-3-5">
        <app-text-input
          [hasIcon]="true"
          ctrlPlaceholder="Unesite adresu"
          [formCtrl]="form().controls.address | formControl"
        >
          <app-home-line stroke="#ADB0B8"></app-home-line>
        </app-text-input>
      </app-field>
      <div class="mt-3-5 flex flex-column md:flex-row align-items-start md:align-items-center gap-3 md:gap-0">
        <app-field label="Grad" for="city" class="flex-1 w-full">
          <app-text-input
            [hasIcon]="true"
            ctrlPlaceholder="Unesite grad"
            [formCtrl]="form().controls.city | formControl"
          >
            <app-marker-pin-01 stroke="#ADB0B8"></app-marker-pin-01>
          </app-text-input>
        </app-field>
        <app-field label="Poštanski broj" for="mb" class="md:ml-4 flex-1 w-full">
          <app-text-input
            [hasIcon]="true"
            ctrlPlaceholder="Unesite poštanski broj"
            [formCtrl]="form().controls.postalCode | formControl"
          >
            <app-map-01 stroke="#ADB0B8"></app-map-01>
          </app-text-input>
        </app-field>
      </div>
      <hr class="mt-3-5 text-gray-200"/>
    }
    <div class="mt-3-5 flex justify-content-between align-items-center">
      <app-button [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.MD" (btnClicked)="back.emit()">
        <app-arrow stroke="#181D27" direction="left"></app-arrow>
        <div class="text-sm-semibold text-gray-900">Nazad</div>
      </app-button>
      <app-button [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="next.emit()" [isBtnDisabled]="!isValid()">
        <div class="text-sm-semibold text-white">Nastavi</div>
        <app-arrow stroke="white" direction="right"></app-arrow>
      </app-button>
    </div>
  </div>
</div>
